<template>
  <div class="box flex flex-col">
    <img
      :src="
        `https://api.thumbnail.ws/api/${key}/thumbnail/get?url=${
          project.homepage ? project.homepage : project.html_url
        }&width=600` || 'https://via.placeholder.com/300?text=Loading...'
      "
      :alt="project.name"
    />
    <div class="clear">
      <p class="flex flex-row">
        <small>{{
          new Date(project.updated_at).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })
        }}</small>
        <span
          ><i v-for="lang in langs" :key="lang" :class="lang + ' icon'"></i
        ></span>
      </p>
      <h4 v-if="project.homepage">
        <a :href="project.homepage" target="_blank" class="title">{{
          project.name
        }}</a>
      </h4>
      <h4 v-else>{{ project.name }}</h4>
      <p class="description">
        {{
          toggleText
            ? project.description.substring(0, 50)
            : project.description
        }}{{ project.description.length > 50 && toggleText ? "..." : "" }}
      </p>
      <ReadMoreButton
        v-if="project.description.length > 50"
        :toggleText="toggleText"
        @readMore="handleButton($event)"
      />
    </div>
    <div>
      <span class="flex flex-row">
        <small>
          <a :href="project.html_url" class="btn btn-link" target="_blank"
            >repository</a
          >
        </small>
        <small>
          <a
            v-if="project.homepage"
            :href="project.homepage"
            class="btn btn-link"
            target="_blank"
            >demo</a
          >
        </small>
      </span>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { ReadMoreButton } from "../../components";
export default {
  props: {
    project: Object,
    langs: Array,
  },
  components: { ReadMoreButton },
  setup() {
    const toggleText = ref(true);
    const key = process.env.VUE_APP_THUMBNAIL_KEY;
    const handleButton = (val) => (toggleText.value = val);
    return { toggleText, key, handleButton };
  },
};
</script>
